module.exports = __webpack_public_path__ + "static/media/fashion-designer.dc6c943e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/store/designer/fashion-designer.jpg
// module id = 210
// module chunks = 0